import {
  AssetInformationCardModule,
  CustomerInformationCardModule,
  PageHeader,
  QuoteTierModule,
} from '@korint/folio';

export const DriverInformation = () => {
  return (
    <div className="space-y-8">
      <PageHeader title="Mes informations" />
      <QuoteTierModule showModifyButton={false} showCustomFields={false} variant="policyholder" />
      <CustomerInformationCardModule allowEdition={false} />
      <AssetInformationCardModule allowEdition={false} />
    </div>
  );
};
